<template>
  <mdb-card>
    <mdb-card-body>
      <mdb-card-title class="mb-5">
        <mdb-icon v-if="icon" :icon="icon"/>
        {{title}}</mdb-card-title>
      <mdb-card-text><slot/></mdb-card-text>
    </mdb-card-body>
  </mdb-card>
</template>
<script>
import { mdbCard, mdbCardBody, mdbCardTitle, mdbCardText } from 'mdbvue';
export default {
  name: 'Card',
  components: { mdbCard, mdbCardBody, mdbCardTitle, mdbCardText },
  props: ['title', 'icon']
}
</script>
